import { axios } from '@/utils/request'

const api = {
  orderType: '/basicdata/orderType',
  basicPrice: '/basicdata/basicPrice'
}
// 获取订单类型
export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + '/list',
    method: 'get',
    params: parameter
  })
}

export function getBasicPriceList (parameter) {
  return axios({
    url: api.basicPrice + '/list',
    method: 'get',
    params: parameter
  })
}

// export function saveChannel (parameter) {
//   return axios({
//     url: api.info+(parameter.channelId == 0 ? '/save' : '/update'),
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function del (parameter) {
  return axios({
    url: api.orderType + '/del',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新建
export function save (parameter) {
  return axios({
    url: api.orderType + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 编辑
export function update (parameter) {
  return axios({
    url: api.orderType + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getOrderTypeTree (parameter) {
  return axios({
    url: api.orderType + '/tree',
    method: 'get',
    params: parameter
  })
}

export const channelExport = api.channel + '/export'
